var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crown-config',_vm._g({attrs:{"highlighted":_vm.highlighted,"paper":_vm.paper,"graph":_vm.graph,"shape":_vm.shape,"node":_vm.node,"nodeRegistry":_vm.nodeRegistry,"moddle":_vm.moddle,"collaboration":_vm.collaboration,"process-node":_vm.processNode,"plane-elements":_vm.planeElements,"is-rendering":_vm.isRendering}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }